import * as Ramda from 'ramda';
import { FormHelperText, TextField as MuiTextField } from '@mui/material';
import type { AmendatoryLineItemProps } from '../AmendatoryCoverageLineItemFactory';
import CoverageOptionsWrapper from '../shared/CoverageItemsWrapper';
import useTypingTimeout from '../../../../hooks/useTypingTimeout';
import CoverageOptionsLabel from '../../../../../../../../primeX-underwriter/components/amendatoryCoverages/components/shared/CoverageOptionsLabel';

const AmendNoticeProvision = (props: AmendatoryLineItemProps) => {
  const min = props.rules?.days?.from;
  const max = props.rules?.days?.to;

  const validateInput = (value: number) => {
    if (!value) {
      return 'Input required.';
    }

    if (!props.rules?.days?.step) {
      return;
    }

    if (Ramda.isNil(min) || Ramda.isNil(max)) {
      return;
    }

    if (value < +min || +value > +max) {
      return `Out of range. Must be within ${min} and ${max}`;
    }

    if (value % props.rules?.days?.step !== 0) {
      return `Invalid input. Must be a multiple of ${props.rules?.days?.step}`;
    }
  };

  const typingTimeout = useTypingTimeout(
    (newValue: string) => {
      props.setCoverage({
        id: props.id,
        value: { props: { days: { value: Number(newValue) } } },
      });
    },
    {
      validate: validateInput,
      defaultValue: props.value?.props.days?.value,
    }
  );

  return (
    <CoverageOptionsWrapper>
      <CoverageOptionsLabel htmlFor="amendNoticeProvisionDays">
        Amended Notice Provision Days
      </CoverageOptionsLabel>

      <MuiTextField
        size="small"
        disabled={!props.isSelected}
        name="amendNoticeProvisionDays"
        type="number"
        value={typingTimeout.input}
        onChange={(e: any) => typingTimeout.onChange(e.target.value)}
        inputProps={{
          step: props.rules?.days?.step,
          min,
          max,
        }}
        sx={{
          '& .MuiInputBase-input': {
            height: '0.75rem',
            width: '8rem',
            textAlign: 'left',
            '&:disabled': {
              opacity: 0.15,
            },
          },
        }}
      />
      <FormHelperText style={{ marginTop: 0, marginLeft: '0.5rem' }}>
        {typingTimeout.error}
      </FormHelperText>
    </CoverageOptionsWrapper>
  );
};

export default AmendNoticeProvision;
